<script setup>
import { computed, ref, watch } from 'vue';

// Props 정의
const props = defineProps({
    modelValue: {
        type: [String, Boolean],
        default: false
    },
    categories: {
        type: Array,
        default: () => []
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    width: {
        type: String,
        default: '4.5rem'
    },
    labelEmpty: {
        type: Boolean,
        default: false
    },
    underline: {
        type: Boolean,
        default: false
    },
    isReturnBoolean: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelValue', 'change']);
const selectWidth = computed(() => props.width || '10rem');
const errMessage = ref(props.errmsg);
const ValidationMsg = ref('');
const isReadonly = computed(() => props.readonly);
const isVisible = computed(() => props.visible);
const isChecked = ref(props.modelValue === 'Y' || props.modelValue === true || props.modelValue === '-1');

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

watch(
    () => props.modelValue,
    (newValue) => {
        isChecked.value = newValue === 'Y' || newValue === true || newValue === '-1';
    }
);

const onChange = () => {
    if (isReadonly.value) return;

    isChecked.value = !isChecked.value;

    const newValue = props.isReturnBoolean ? isChecked.value : isChecked.value ? 'Y' : 'N';

    emit('change', { id: props.inputId, value: newValue });
    emit('update:modelValue', newValue);
};

const onLabelClick = () => {
    emit('change', { value: 'label' });
};

const onClick = (event) => {
    if (isReadonly.value) {
        event.preventDefault();
        return;
    }
    event.preventDefault();
    if (props.underline) onLabelClick();
    // else onChange();
};

console.log('[DEBUG] label:', props.label);
</script>

<template>
    <div
        v-if="visible"
        class="flex flex-col"
        :id="inputId"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label v-if="!labelEmpty" :class="['label-font mb-1 mx-1', required ? 'label-required' : 'text-gray-700 dark:text-gray-300']">
            <!-- {{ label }} -->
            <span v-if="required" class="required-asterisk">*</span>
            <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
        </label>
        <div class="checkbox-container">
            <div class="checkbox-item">
                <input type="checkbox" :id="inputId" :disabled="isReadonly" :checked="isChecked" @change="onChange" class="form-checkbox checkbox-input" />
                <label class="checkbox-label" :style="{ width: selectWidth, textDecorationLine: underline ? 'underline' : '', cursor: underline ? 'pointer' : 'default' }" @click="onClick">
                    {{ label }}
                </label>
            </div>
        </div>
    </div>
</template>

<style scoped>
.label-font {
    font-family: 'SCoreDream600';
    height: 1.3rem;
    font-size: 0.875rem;
}

.required-asterisk {
    color: #f87171; /* 빨간색 */
    margin-left: 0.2rem;
    position: relative;
    top: -0.2rem;
}

.checkbox-container {
    display: flex;
    flex-wrap: nowrap;
    height: 3rem;
}

.checkbox-item {
    display: flex;
    align-items: center;
    margin-right: 1rem;
}

.checkbox-label {
    margin-left: 0.2rem;
    cursor: pointer;
    font-family: 'SCoreDream500';
    font-size: 0.875rem;
    white-space: nowrap;
    margin-top: 0.1rem;
}

.checkbox-input {
    cursor: pointer;
    width: 2.5rem;
    height: 1.5rem;
}

.error-border {
    border-color: #f87171 !important; /* 빨간색 테두리 */
}
.validation-message {
    color: #f87171; /* red-500 */
    font-size: 0.75rem;
    margin-left: 0.5rem;
}
</style>
